import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface LenderRouteProps {
  children: React.ReactNode;
}

export const LenderRoute: React.FC<LenderRouteProps> = ({ children }) => {
  const { isAuthenticated, isAdmin, hasRole, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const canAccess = isAdmin || hasRole('lender-manager');

  if (!canAccess) {
    return (
      <div
        style={{
          padding: '2rem',
          textAlign: 'center',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '8px',
          margin: '2rem auto',
          maxWidth: '600px',
        }}
      >
        <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>Access Denied</h2>
        <p style={{ color: '#6c757d', fontSize: '1.1rem' }}>
          You need the lender manager role to access this page.
        </p>
        <p style={{ color: '#6c757d', marginTop: '1rem' }}>
          Please contact an administrator if you believe you should have access.
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default LenderRoute;
